// extracted by mini-css-extract-plugin
export default {"affirmative":"Affirmative-module__affirmative__lo8bBNO","copilotRun":"Affirmative-module__copilotRun__nnefqFx"};